import React from 'react';
import { useKnipsDataContext } from '../helpers/DataContext';

function KnipsModule() {
  const { adId, knipsId, knipsContentUrl } = useKnipsDataContext();
  const getKnipsContentUrl = () => {
    if (knipsContentUrl.includes('KNIPSID') && knipsContentUrl.includes('ADID')) {
      return knipsContentUrl.replace('KNIPSID', knipsId.toString()).replace('ADID', adId.toString());
    }
    return knipsContentUrl;
  };

  return (
    <iframe
      title="Knips"
      src={getKnipsContentUrl()}
      scrolling="no"
      style={{ width: '100%', height: '664px', overflow: 'hidden' }}
      sandbox="allow-same-origin allow-scripts allow-popups"
    />
  );
}

export default KnipsModule;
